export enum slice {
    APP = 'APP',

    AUTH = 'AUTH',
    FORM = "formSlice",
    MODAL = "MODAL",
    ALERT = 'alert',
}

 
  export enum app {

  }

  export enum page{
    
  }